// extracted by mini-css-extract-plugin
export default {"numbers-container":"Numbers_numbers-container__1K60n","numbers":"Numbers_numbers__CQjNI"};